<script lang="ts" setup>
import LayoutEnum from '~/enums/LayoutEnum'
import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'

const { type } = defineProps<{ type?: LayoutEnum.Market | LayoutEnum.Quote }>()
const { t } = useLang()
const route = useRoute()

const isHome = computed(() => route.name === `${PagesPrefixEnum}${Routes.Index}`)
</script>

<template>
  <div class="ae-header-nav">
    <div class="navbar">
      <nav class="nav flex gap-2 h-full" role="menubar">
        <NuxtLink :to="getLocalizedRoute(Routes.Index)" class="nav-item" :class="{ active: isHome }">
          {{ t('nav.home') }}
        </NuxtLink>

        <NuxtLink
          :to="getLocalizedRoute(Routes.OrderForm.Index)"
          class="nav-item order-form"
          :class="{ active: type === LayoutEnum.Quote }">
          {{ t('quotes.order-form') }}
        </NuxtLink>
      </nav>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ae-header-nav {
  .navbar {
    @apply text-text1 border-none p-0 shadow-none;

    .nav {
      .nav-item {
        @apply text-[1.125rem] px-4 py-5 whitespace-nowrap font-extrabold;

        &.active {
          @apply text-orange;
        }
      }
    }
  }
}
</style>
